import './collegas.scss';
import { bootstrapOverlappingSliders } from '@/js/lib/overlap-slider.js';

// De slider-mechanica (Draggable + Inertia + snap/keyboard/nav) leeft in de
// gedeelde lib zodat o.a. `vacatures-slider` exact dezelfde werking hergebruikt.
// Het collega-block houdt zijn overlap-stack via data-scale/data-rotate in de
// markup (collegas.php).
bootstrapOverlappingSliders();
